<template>
  <div class="public-print-list" v-if="parameter.visable">
    <el-dialog class="public-print-list-dialog" :visible.sync="parameter.visable" title="引用" width="670px" height="378px" center :close-on-click-modal="false">
      <div class="dialog-content">
        <div class="table">
          <el-table v-if="tableData.length" :data="tableData" v-loading="loading" height="240px" header-row-class-name="header-class">
            <el-table-column prop="name"
                             label="名称"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
             <el-table-column
                             prop="dataSourceReport"
                             label="引用类型"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="createTime"
                             label="创建时间"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
          <div v-else class="no-list">
            <img src="./assets/nothing.png" alt="无内容">
            <p>暂无引用记录</p>
          </div>
        </div>
      </div>

      <span slot="footer">
        <el-button @click="parameter.visable = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'form-quote-list',
  props: ['parameter'],
  data () {
    return {
      tableData: [],
      loading: true
    }
  },
  methods: {
    loadList () {
      let url = `/form-api/defines/formQuote/${this.parameter.id}`
      this.$axios.get(`${url}`).then(res => {
        this.tableData = res.data || []
        this.tableData.forEach(el => {
          el.dataSourceReport = el.dataSourceReport ? '辅助表' : '报表'
        })
      })
    }
  },
  watch: {
    'parameter.visable' (val) {
      if (val) {
        try {
          this.loadList()
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .public-print-list-dialog {
    .el-dialog.el-dialog--center{
      margin-top: 14% !important;
        .el-dialog__header {
          padding: 5px 20px;
        }
        .el-dialog__body {
          padding: 20px 20px 0 20px;
          height: 300px;
        }

        .dialog-content {
          .add-button {
            width: 58px;
            height: 24px;
            line-height: 24px;
            padding: 0;
            float:right;
            margin-bottom: 10px;
          }
          & > .table {
            .no-list {
              margin: 0 auto 0;
              text-align: center;
              color: #999999;
              font-size: 12px;
              height: 200px;
              padding-top: 70px;
            }
            .del-row {
              color: #A5A5A5;

              &:hover {
                color: #F64D5E;
              }

              &:active {
                color: #FB9391;
              }
            }

            .el-table__header {
              border-bottom: 1px solid #EBEBEB;
            }

            .header-class {
              th {
                background-color: #fff;
              }
            }
          }

        }

        .el-dialog__footer {
          padding: 31px 0 21px 0;

          .el-button {
            width:84px;
            height:26px;
            border-radius:4px;
            padding: 0;
          }
        }
    }
  }
  .create-template-dialog {
    >.el-dialog.el-dialog--center {
      margin-top: 22% !important;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 48px 36px 28px;
        .el-input {
          width: 220px;
        }
      }
      .el-dialog__footer {
        padding-top: 0;
        .dialog-footer {
          .el-button {
            padding: 5px 26px;
            &:nth-child(2){
              margin-left: 42px;
            }
          }

        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/shared/form-quote-list.vue